
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { DATE_TYPE } from '@/const/types';

const defaultPicker = {
    shortcuts: [
        {
            text: '이번 달',            
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setDate(1); start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setDate(1); end.setHours(0); end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '지난 달',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 1);
                end.setMonth(end.getMonth() - 1);
                start.setDate(1); start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setDate(1); end.setHours(0); end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '최근 2개월',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 1);
                start.setDate(1); start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setDate(1); end.setHours(0); end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '최근 3개월',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 2);
                start.setDate(1); start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setDate(1); end.setHours(0); end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '최근 6개월',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 5);
                start.setDate(1); start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setDate(1); end.setHours(0); end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '최근 1년',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 11);
                
                start.setDate(1); start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setDate(1); end.setHours(0); end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
    ],
};

@Component<MonthRangePicker>({
    name: 'MonthRangePicker',
})
export default class MonthRangePicker extends Vue {
    @Prop({ type: Boolean, default: false }) private disabled!: boolean;
    @Prop({ type: String, default: '' }) private className!: string;
    @Prop({ type: Array, default: ['', ''] }) private value!: string[];
    @Prop({ type: String, default: '시작일' }) private startPlaceholder!: string;
    @Prop({ type: String, default: '종료일' }) private endPlaceholder!: string;
    @Prop({ type: Object, default: () => defaultPicker}) private pickerOptions!: {
        [key: string]: any;
        shortcuts: {
            [key: string]: any;
            text: string;
        };
    };
    @Prop({ type: Function, default: (v: Date[]) => {}}) private change!: (v: Date[]) => any;
    @Prop({ type: Array, default: () => []}) private pickerRange!: string[];
    @Prop({ type: Number, default: 12}) private maxMonth!: number;
    @Prop({ type: String, default: 'right'}) private align!: string;

    get model() {
        return this.value;
    }
    set model(v) {
        if (v) {
            const tmp = v as DATE_TYPE[];
            const times = tmp as Date[];

            const yearDiff = times[1].getFullYear() - times[0].getFullYear();
            const monthBase = yearDiff >= 0 ? yearDiff * 12 : -yearDiff * 12;

            let diff = times[1].getMonth() - times[0].getMonth();
            diff = monthBase + diff;
            if ( -this.maxMonth < diff && diff < this.maxMonth) {
                this.$emit('input', v);
                return;
            }
            this.$notify.error(`최대 ${this.maxMonth}개월까지 조회가 가능합니다.`);
        }
        this.$emit('input', v);
    }

    get pickers() {
        if (this.pickerRange.length === 0) {
            return {
                ...this.pickerOptions,
                disabledDate: this.disabledDate,
            };
        }
        return {
            ...this.pickerOptions,
            shortcuts: this.pickerRange.map((rule: string) => {
                return this.pickerOptions.shortcuts.find(
                    (v: {text: string, [key: string]: any}) => v.text === rule
                );
            }),
            disabledDate: this.disabledDate,
        }
    }
    

    private disabledDate(time: Date) {
        return time.getTime() > Date.now();
    }
}

